import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import CLocalizedTextString from '../../components/CLocalizedTextString';
import { PageRoutes } from '../../enums/enums';
import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';

export default function CacheManagementOutlet() {
  const dispatch = useAppDispatch();
  const cacheManagementPageTitle = CLocalizedTextString('cacheManagement.title');

  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.CACHE_MANAGEMENT_OUTLET, cacheManagementPageTitle]));

    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch]);

  return <Outlet />;
}
